import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
const providerOrigins: ReadonlySet<string> = new Set(['https://sell.moonpay.com', 'https://sell-sandbox.moonpay.com']);
// Provider authentication needs its own origin. The allowlist prevents a same-origin
// document from using scripts to remove the sandbox from Morfi's DOM.
const providerSandbox: string = ['allow-scripts', 'allow-same-origin', 'allow-forms', 'allow-popups', 'allow-popups-to-escape-sandbox', 'allow-top-navigation-by-user-activation'].join(' ');
export function SellProviderFrame(t0) {
  const $ = _c(2);
  const {
    url
  } = t0;
  if (!providerOrigins.has(new URL(url).origin)) {
    throw new Error("offramp_invalid_checkout_origin");
  }
  let t1;
  if ($[0] !== url) {
    t1 = <iframe title="MoonPay" src={url} allow="camera; payment" sandbox={providerSandbox} className="h-145 w-full border-0" />;
    $[0] = url;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}